/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".widget.mat-card[_ngcontent-%COMP%]{height:225px}\n/*# sourceMappingURL=feature-flag-widget.component.css.map*/"];
export { styles as styles };
